import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "more",
  "use": "more-usage",
  "viewBox": "0 0 4 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 4 21\" id=\"more\"><path fill-rule=\"evenodd\" d=\"M2 8.503a1.997 1.997 0 110 3.994 1.997 1.997 0 110-3.994zM0 1.997C0 3.1.894 3.994 2 3.994A1.997 1.997 0 102 0C.894 0 0 .893 0 1.997zm0 17.006C0 20.107.894 21 2 21a1.997 1.997 0 100-3.994c-1.106 0-2 .893-2 1.997z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol